import PhoneInput from './PhoneInput'
import NumberInput from './NumberInput'
import CodeInput from './CodeInput'
import PasswordInput from './PasswordInput'
import TextInput from './TextInput'
import SelectInput from './SelectInput'
import TemplateSelectInput from './TemplateSelectInput'
import TextAreaInput from './TextAreaInput'
import ProfileImageInput from './ProfileImageInput'
import ProfileImageInput2 from './ProfileImageInput2'
import SelectListInput from './SelectListInput'
import CheckboxInput from './CheckboxInput'
import FromToInput from './FromToInput'
import PriceInput from './PriceInput'
import SliderInput from './SliderInput'
import AdvancedSelectInput from './AdvancedSelectInput'
import MultiSelectInput from "./MultiSelectInput"
import ImageInput from "./ImageInput"
import SubformInput from "./SubformInput"
import SwitchInput from './SwitchInput'
import MapInput from './MapInput'
import SmartInput from './SmartInput'
import FilterEditor from './FilterEditor'
import IconManagerInput from './IconManagerInput'
import UsernameInput from './UsernameInput'
import DateInput from './DateInput'
import ColorInput from './ColorInput'
import GlobalUserInput from './GlobalUserInput'
import FileInput from './FileInput'
import InvoiceInput from './InvoiceInput'
import FormSection from './FormSection'
import MultiLevelSelect from './MultiLevelSelect'
import ProfileImageRowInput from './ProfileImageRowInput'
import SelectAppletInput from './SelectAppletInput'
import EditorInput from './EditorInput'
import EditorInputNew from './EditorInputNew'
import ImageSelectInput from './ImageSelectInput'
import CalendarInput from './CalendarInput'
import StatusSelectInput from './StatusSelectInput'
import GlobalUserMultiInput from './GlobalUserMultiInput'
import GlobalGroupsMultiInput from './GlobalGroupsMultiInput'
import WorkingHoursInput from './WorkingHoursInput'
import CheckBoxListInput from './CheckBoxListInput'
import FormCreateInput from './FormCreateInput'
import MapLeafletInput from './MapLeafletInput'
import ExtraSettingsInput from './ExtraSettingsInput'
import BarCodeGeneratorInput from './BarCodeGeneratorInput'

import AvailabilityTimeInput from './AvailabilityTimeInput'
import EmptyInput from './EmptyInput'
import MultipleChoiceInput from './MultipleChoiceInput'
import UnicIdInput from './UnicIdInput'
import TimeInput from './TimeInput'
import DateTimeInput from './DateTimeInput'
import RoomChangeLayout from './RoomChangeLayout'
import EditList from './EditList'
import LocalSelectInput from './LocalSelectInput'
import AdvancedColorInput from './AdvancedColorInput'
import PermissionsInput from './PermissionsInput'
import StaticText from './StaticText'
import CombinedInput from './CombinedInput'
import DurationInput from './DurationInput'
import CategorizerInput from './CategorizerInput'
import FilterEditorInput from './FilterEditorInput'
import OutputsInput from './OutputsInput'
import FieldsInput from './FieldsInput'
import FrameSelector from './FrameSelector'
import LookupInput from './LookupInput'
import StageInput from './StageInput'
import ChartFieldInput from './ChartFieldInput'
import MultiTreeSelectAddListing from './MultiTreeSelectAddListing'
import AdvancedMultiTreeSelect from './AdvancedMultiTreeSelect'
import CardBuilder from './CardBuilder'
import TextEditorInput from './TextEditorInput'
import SidesInput from './SidesInput'
import ApisInput from './ApisInput'
import PathInput from './PathInput'
import ParamsInput from './ParamsInput'
import VideoInput from './VideoInput'
import InvoiceInput2 from './InvoiceInput2'
import RangeNumberInput from './RangeNumberInput'
import FormulaInput from './FormulaInput'
import TagInput from './TagInput'
import VariantsInventory from './VariantsInventory'
import DimensionsInput from './DimensionsInput'
import StockInput from './StockInput'
import AddressInput from './AddressInput'
import CodeGeneratorInput from './CodeGeneratorInput'
import ThirdPartyInput from './ThirdPartyInput'
import RegionsInput from './RegionsInput'
import MultiContentInput from './MultiContentInput'
import BoxShadowInput from './BoxShadowInput'
import ColumnsCountInput from './ColumnsCountInput'
import ProductSelectInput from './ProductSelectInput'
import LicenseInput from './LicenseInput'
import HubStatusIndicator from './HubStatusIndicator'
import GroupsSelectInput from './GroupsSelectInput'
import FormBuilderInput from './FormBuilderInput'
import QuestionBuilderInput from './QuestionBuilderInput'
import FormInput from './FormInput'
import RequestsInput from './RequestsInput'
import FrameSelectInput from './FrameSelectInput'
import FilterInput from './FilterInput'
import HubsAndGroupsInput from './HubsAndGroupsInput'
import TriggerSelectInput from './TriggerSelectInput'
import FormViewerInput from './FormViewerInput'
import DynamicInput from './DynamicInput'
import StagesSelectInput from './StagesSelectInput'
import VariablesInput from "./VariablesInput"
import AutoIdInput from "./AutoIdInput"
import RecieveFullAmountInput from './RecieveFullAmountInput'
import UnpaidInvoicesInput from './UnpaidInvoicesInput'

const inputComponents = {

    EditList,
    AdvancedColorInput,
    PermissionsInput,
    LocalSelectInput,
    PhoneInput,
    NumberInput,
    CodeInput,
    PasswordInput,
    TextInput,
    SelectInput,
    TemplateSelectInput,
    TextAreaInput,
    ProfileImageInput,
    ProfileImageInput2,
    SelectListInput,
    CheckboxInput,
    FromToInput,
    PriceInput,
    SliderInput,
    AdvancedSelectInput,
    ExtraSettingsInput,
    BarCodeGeneratorInput,
    MultiSelectInput,
    ImageInput,
    SubformInput,
    SwitchInput,
    MapInput,
    SmartInput,
    FilterEditor,
    IconManagerInput,
    UsernameInput,
    DateInput,
    ColorInput,
    GlobalUserInput,
    FileInput,
    InvoiceInput,
    FormSection,
    MultiLevelSelect,
    ProfileImageRowInput,
    EditorInput,
    EditorInputNew,
    SelectAppletInput,
    ImageSelectInput,
    CalendarInput,
    StatusSelectInput,
    GlobalUserMultiInput,
    GlobalGroupsMultiInput,
    WorkingHoursInput,
    CheckBoxListInput,
    FormCreateInput,
    MapLeafletInput,
    AvailabilityTimeInput,
    EmptyInput,
    MultipleChoiceInput,
    UnicIdInput,
    TimeInput,
    DateTimeInput,
    RoomChangeLayout,
    StaticText,
    CombinedInput,
    SectionIndicator: StaticText,
    DurationInput,
    CategorizerInput,
    FilterEditorInput,
    OutputsInput,
    FieldsInput,
    FrameSelector,
    LookupInput,
    StageInput,
    ChartFieldInput,
    MultiTreeSelectAddListing,
    AdvancedMultiTreeSelect,
    CardBuilder,
    TextEditorInput,
    SidesInput,
    ApisInput,
    PathInput,
    ParamsInput,
    VideoInput,
    InvoiceInput2,
    RangeNumberInput,
    FormulaInput,
    TagInput,
    VariantsInventory,
    DimensionsInput,
    MultiContentInput,
    StockInput,
    AddressInput,
    CodeGeneratorInput,
    ThirdPartyInput,
    RegionsInput,
    BoxShadowInput,
    ColumnsCountInput,
    ProductSelectInput,
    LicenseInput,
    HubStatusIndicator,
    GroupsSelectInput,
    FormBuilderInput,
    QuestionBuilderInput,
    FormInput,
    RequestsInput,
    FrameSelectInput,
    FilterInput,
    HubsAndGroupsInput,
    TriggerSelectInput,
    FormViewerInput,
    DynamicInput,
    StagesSelectInput,
    VariablesInput,
    AutoIdInput,
    RecieveFullAmountInput,
    UnpaidInvoicesInput

}


export default (inputComponents);